import { ProgressSpinner } from 'primereact/progressspinner';

type Props = {
  height?: string;
  width?: string;
};

const Spinner = ({ height = '100px', width = '100px' }: Props) => (
  <ProgressSpinner
    style={{
      display: 'flex',
      alignItems: 'center',
      height,
      width,
    }}
    strokeWidth="3"
  />
);

export default Spinner;
